import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { WorkoutView } from "@/components/WorkoutView";
import { useAuth } from "@/context/AuthContext";
import { tr } from "@/data/i18n";

export default function PlanView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { lang } = useAuth();
  const [plan, setPlan] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.getPlan(id).then(({ data }) => setPlan(data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) return <div className="py-24 text-center text-zinc-500">404 · Scheda non trovata</div>;
  if (!plan) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="animate-spin text-red-500" size={40} /></div>;

  return (
    <div>
      <div className="mx-auto max-w-5xl px-4 sm:px-6 pt-6">
        <button onClick={() => navigate("/saved")} className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white">
          <ArrowLeft size={16} /> {tr(lang, "back")}
        </button>
      </div>
      <WorkoutView plan={plan} setPlan={setPlan} />
    </div>
  );
}
